import {
  Fade,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../localization'
import { Tenant } from '../../types/tenants'
import TanantRowSkeleton from './TanantRow.skeleton'
import TenantRow from './TenantRow'
import useStyles from './styles/TenantTable.styles'

interface TenantTableProps {
  tenants: Tenant[]
  loading: boolean
  refetch: () => void
}

const TenantTable: React.FC<TenantTableProps> = ({
  tenants,
  loading,
  refetch
}) => {
  const theme = useTheme()
  const classes = useStyles()

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div>
      <div className={classes.tableHead}>
        <div>
          <Typography variant="body1">
            {getTranslate(`${isSmallScreen ? '' : 'Tenant '}Name`)}
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            {getTranslate(`${isSmallScreen ? '' : 'Tenant '}Code`)}
          </Typography>
        </div>
        <div>
          <IconButton
            onClick={() => {
              refetch()
            }}>
            <RefreshIcon />
          </IconButton>
        </div>
      </div>
      {loading
        ? Array(5)
            .fill(null)
            .map(() => <TanantRowSkeleton />)
        : tenants.map((item) => (
            <Fade in timeout={600} key={item.basicDetails.tenantCode}>
              <TenantRow data={item} />
            </Fade>
          ))}
    </div>
  )
}
export default TenantTable
